// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__huAxU","tabs":"Tabs_tabs__Er7Za","tab":"Tabs_tab__p3TDa","active":"Tabs_active__vvKI4","content":"Tabs_content__e5d-B"};